function getOpt (data, perData) {
 let { dateValue: xData, value: yData } = data
 let perList = [];
 for (let i = 0; i < perData.length; i++) {
  if (perData[i] == '--') continue
  perList[i] = { value: '', color: '' }
  perList[i]['value'] = Number(perData[i]).toFixed(2) + '%';
  if (Number(perData[i]) > 0) {
   perList[i]['color'] = 'red'
  } else {
   perList[i]['color'] = 'green'
  }
 }
 let markLineData = [];
 for (let i = 0; i < yData.length; i++) {
  let markLineItem = [{ coord: [i, yData[i]] }, { coord: [i + 1, yData[i + 1]], symbol: 'circle' }]
  markLineData.push(markLineItem)
 }
 return {
  tooltip: {
   show: true,
   trigger: 'axis',
   backgroundColor: 'rgba(4, 21, 39, 1)',
   borderWidth: 0,
   textStyle: {
    color: '#fff'
   },
  },
  xAxis: {
   type: 'category',
   axisLabel: {
    color: '#D7D7D7',
    fontSize: 14,//bar字体设置
    interval: 0
   },
   splitLine: {
    show: false
   },
   axisLine: {
    lineStyle: {
     color: "#093E95",
     width: 1
    }
   },
   axisTick: {
    show: false
   },
   data: xData
  },
  yAxis: {
   type: 'value',
   name: '万吨',
   nameTextStyle: {
    color: '#fff',
   },
   axisLine: {
    show: true,
    lineStyle: {
     color: "#093E95"
    }
   },
   splitLine: {
    show: false
   },
   axisLabel: {
    color: '#D7D7D7',
    fontSize: 14//bar字体设置
   },
  },
  grid: {
   left: "8%",
   top: "15%",
   width: 500,
   height: 120
  },
  series: [
   {
    data: yData,
    barWidth: 40,//柱图宽度
    type: 'bar',
    itemStyle: {
     barBorderRadius: [4, 4, 0, 0],
     color: '#8DE4F3'
    },
    markLine: {
     data: markLineData,
     label: {
      show: true,
      position: 'middle',
      distance: [0, 5],
      fontSize: 18,
      formatter: (params) => {
       if (perList[params.dataIndex]) {
        if (perList[params.dataIndex].color == 'red') {
         return "{red|" + perList[params.dataIndex].value + "}";
        } else {
         return "{green|" + perList[params.dataIndex].value + "}";
        }
       }

      },
      rich: {
       red: {
        align: "center",
        color: "red",
        fontSize: 18,
       },
       green: {
        align: "center",
        color: "green",
        fontSize: 18,
       },
      },
     },

    },
   },

  ]
 }
};

export default getOpt